import "../../assets/scss/app.scss";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

class Main {
  constructor() {
    const option = {
      effect: "fade",
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 3000,
      },
    };
    const swiper = new Swiper(".swiper", option);

    // fadeIn
    function fadeIn(elm, ms) {
      elm.style.opacity = 0; // 透過度０
      elm.style.display = "block";
      elm.style.transition = "opacity " + ms + "ms";
      setTimeout(function () {
        elm.style.opacity = 1;
      }, 1); // 0.001秒後に transition開始(透過度１にする）
    }
    // fadeOut
    function fadeOut(elm, ms) {
      elm.style.opacity = 1; // 透過度1
      elm.style.transition = "opacity " + ms + "ms";
      setTimeout(function () {
        elm.style.opacity = 0;
      }, 5); // 0.001秒後に transition開始（透過度0にする）
      setTimeout(function () {
        elm.style.display = "none";
      }, ms + 10); // 1.01秒後に完全に消す。
    }

    const menuBtn = document.querySelector(".menuBtn");
    const menu = document.querySelector("#menu");
    const menuLink = document.querySelectorAll("#menu a");
    let menuFlg = false;
    menuBtn.addEventListener("click", () => {
      if (menuFlg === false) {
        menuFlg = true;
        menuBtn.classList.add("act");
        fadeIn(menu, 500);
      } else {
        menuFlg = false;
        menuBtn.classList.remove("act");
        fadeOut(menu, 500);
      }
    });
    menuLink.forEach((link) => {
      link.addEventListener("click", () => {
        menuFlg = false;
        menuBtn.classList.remove("act");
        fadeOut(menu, 500);
      });
    });

    function pagelink(e) {
      e.preventDefault();
      let headerHeight = $("header").outerHeight();
      let urlHash = location.hash;
      if (urlHash) {
        let position = $(urlHash).offset().top - headerHeight * 2;
        $("html, body").animate({ scrollTop: position }, 0);
      }
    }
    $(window).on("load", function (e) {
      pagelink(e);
    });
    window.addEventListener("hashchange", function (e) {
      pagelink(e);
    });

    // IE、Safari対応
    // smoothscroll.js読み込み
    // https://github.com/iamdustan/smoothscroll

    // セレクタ名（.pagetop）に一致する要素を取得
    const pagetop_btn = document.querySelector(".pageTop");

    // .pagetopをクリックしたら
    pagetop_btn.addEventListener("click", scroll_top);

    // ページ上部へスムーズに移動
    function scroll_top() {
      window.scroll({ top: 0, behavior: "smooth" });
    }

    // スクロールされたら表示
    window.addEventListener("scroll", scroll_event);
    function scroll_event() {
      if (window.pageYOffset > 100) {
        pagetop_btn.style.opacity = "1";
      } else if (window.pageYOffset < 100) {
        pagetop_btn.style.opacity = "0";
      }
    }
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new Main();
});
